import React from "react";
import "./i18n";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import DashboardRouter from "./pages/DashboardRouter";
import PlayerProfile from "./pages/PlayerProfile";
import PlayersBrowse from "./pages/PlayersBrowse";
import Billing from "./pages/Billing";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import Messages from "./pages/Messages";
import CountryPage from "./pages/CountryPage";
import ForgotPassword from "./pages/ForgotPassword";
import ScrollToHash from "./components/ScrollToHash";
import InstallPWA from "./components/InstallPWA";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToHash />
          <Toaster theme="dark" position="top-right" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/players" element={<PlayersBrowse />} />
            <Route path="/players/:id" element={<PlayerProfile />} />
            <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
            <Route path="/country/:country" element={<CountryPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardRouter />
                </ProtectedRoute>
              }
            />
          </Routes>
          <InstallPWA />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
